/**
 * Avira Browser Safety
 *
 * Exposes a set of stably-named HTML surfaces (html/top.html, html/blocked.html) to
 * every origin.
 *
 * Manifest verified against version 4.3.1.57.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'flliilndjeohchalpbbcdekjklbdgfkk';

export const aviraBrowserSafety: ExtensionDefinition = {
  id: ID,
  name: 'Avira Browser Safety',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 7_000_000,
  signals: [
    {
      id: 'war-top-html',
      kind: 'web-accessible-resource',
      description: 'Fetch html/top.html — an injected UI frame, exposed to <all_urls>.',
      weight: 1,
      run: () => probeFetch(ID, 'html/top.html'),
    },
    {
      id: 'war-blocked-html',
      kind: 'web-accessible-resource',
      description: 'Fetch html/blocked.html — the interstitial shown for blocked sites.',
      weight: 0.5,
      run: () => probeFetch(ID, 'html/blocked.html'),
    },
  ],
};
